import getCharts from "../getCharts"
import { PatientPsychiatryNotesCRUD } from "../../constants/api.config"

export default async function PsychiatryNotesCRUD(
  mode = "GET",
  patientID = "-1",
  PsychiatryNotes = "",
  pdate = "",
  id = ""
) {
  try {
    const payload = { mode, patientID, PsychiatryNotes, pdate, id }

    const res = await getCharts(PatientPsychiatryNotesCRUD, payload)

    return res.data
  } catch (error) {
    return error
  }
}